export const queryStrings = {
    chat: 'c',
    search: 'q',
    subCategory: 'sub',
    page: 'page',
    category: 'cat',
    discussion: 'd',
};
